import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/alerts/")({
  staticData: {
    title: "common.alerts",
  },
  loader: ({ params }) => {
    throw redirect({
      to: "/sources/fleets/$id/alerts/no-data-alert/trigger",
      params,
      replace: true,
    });
  },
});
